import type { MyReview } from "@coterie/types";
import { venueName, venueStreet } from "./venues.ts";

export const ago = (iso: string) => {
  const s = Math.max(0, (Date.now() - Date.parse(iso)) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  const d = Math.floor(s / 86400);
  return d === 1 ? "1 day ago" : `${d} days ago`;
};

function CheckIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M20 6 9 17l-5-5" />
    </svg>
  );
}

function CloseIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M18 6 6 18" />
      <path d="m6 6 12 12" />
    </svg>
  );
}

type Props = MyReview & {
  handle?: string;
  isSeeder?: boolean;
};

export function ReviewCard({
  venueId,
  recommend,
  hotTake,
  photoKey,
  createdAt,
  handle,
  isSeeder,
}: Props) {
  const name = venueName(venueId);
  const street = venueStreet(venueId);
  const own = !handle;
  return (
    <li className="history-card">
      <img src={`/${photoKey}`} alt="" loading="lazy" />
      <div className="history-body">
        <div className="history-head">
          <div className="history-copy">
            {own ? (
              <p className="history-line">
                {name} <span className="meta">{ago(createdAt)}</span>
              </p>
            ) : (
              <p className="history-line">
                <span className="handle">{handle}</span> reviewed {name}
                {isSeeder && <span className="pill">seeder</span>}
              </p>
            )}
            {own
              ? street && <p className="meta">{street}</p>
              : (
                  <p className="meta">
                    {ago(createdAt)}
                    {street ? ` · ${street}` : ""}
                  </p>
                )}
          </div>
          <div
            className={recommend ? "verdict-tile yes" : "verdict-tile no"}
            aria-label={recommend ? "yes" : "no"}
          >
            {recommend ? <CheckIcon /> : <CloseIcon />}
          </div>
        </div>
        {hotTake && <p className="history-take">{hotTake}</p>}
      </div>
    </li>
  );
}
